export const hotelGalleryTitleMockData = {
  property: {
    id: 'NYCES',
    basicInformation: {
      name: 'Courtyard New York Manhattan/Fifth Avenue',
      latitude: 40.752132,
      longitude: -73.981665,
      isAdultsOnly: false,
      brand: { id: 'CY', __typename: 'Brand' },
      openingDate: '2005-01-22',
      bookable: true,
      resort: false,
      descriptions: [
        {
          text: "Set off with confidence at Courtyard New York Manhattan/Fifth Avenue. Our hotel places you in the thick of Midtown, just walking distance from Times Square, Bryant Park, Rockefeller Center and the Theatre District. Take Grand Central Station to the Staten Island Ferry or explore Saks Fifth Avenue, Macy's and other shopping near the hotel. After a day in Bryant Park, visit our 24-hour fitness center with free weights and treadmills or return to your clean, inviting and space-savvy hotel room with ergonomic workstations. Each hotel room offers free Wi-Fi, safes and luxury bedding. Close the day with premium movies or HBO shows on a flat-screen TV. Your passion is our passion at Courtyard New York Manhattan/Fifth Avenue.",
          type: {
            code: 'description',
            label: null,
            description: 'Description which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Conveniently located in the heart of the city near popular attractions such as Grand Central Terminal, Bryant Park, Fifth Avenue and the New York Public Library, Courtyard New York Manhattan/Fifth Avenue is a great spot to explore the city from.',
          type: {
            code: 'longDescription',
            label: null,
            description: 'Long Description which is always in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Conveniently located in the heart of the city near popular attractions such as Grand Central Terminal, Bryant Park, Fifth Avenue and the New York Public Library, Courtyard New York Manhattan/Fifth Avenue is a great spot to explore the city from.',
          type: {
            code: 'shortDescription',
            label: null,
            description: 'Short Description which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Take advantage of the modern amenities offered at Courtyard New York Manhattan/Fifth Avenue such as free Wi-Fi, fitness center and spacious accommodations. This hotel is near the New York Public Library and Bryant Park.',
          type: {
            code: 'salesMessage',
            label: null,
            description: 'Sales message which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Take advantage of the modern amenities offered at Courtyard New York Manhattan/Fifth Avenue such as free Wi-Fi, fitness center and spacious accommodations. This hotel is near the New York Public Library and Bryant Park.',
          type: {
            code: 'location',
            label: null,
            description: 'Location description which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Move forward boldly in Bryant Park',
          type: {
            code: 'headerMessage',
            label: null,
            description: 'Header text for hotel website which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Modern hotel with free Wi-Fi and Fitness Center near Bryant Park and Fifth Avenue.',
          type: {
            code: 'hotelMarketingCaption',
            label: null,
            description: 'Key selling point for hotel marketing which may not be in language',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
        {
          text: 'Reset and recharge in our Midtown Manhattan hotel',
          type: {
            code: 'room-header-caption',
            label: null,
            description: 'Room Header Caption',
            __typename: 'Lookup',
          },
          __typename: 'PropertyDescription',
        },
      ],
      __typename: 'HotelBasicInformation',
    },
    contactInformation: {
      address: {
        line1: '3 East 40th Street',
        city: 'New York',
        postalCode: '10016',
        stateProvince: { label: null, description: 'New York', code: 'NY', __typename: 'Lookup' },
        __typename: 'PropertyAddress',
      },
      contactNumbers: [
        {
          phoneNumber: {
            international: '+1 212 447 1500',
            display: '+1 212 447 1500',
            countryCode: '+1',
            national: '(212) 447-1500',
            original: '+12124471500',
            __typename: 'PhoneNumber',
          },
          type: { description: 'Phone', __typename: 'Lookup' },
          __typename: 'ContactNumber',
        },
      ],
      __typename: 'PropertyContactInformation',
    },
    airports: [
      {
        name: 'LaGuardia Airport (LGA)',
        distanceDetails: { description: '8.2 mi SW', __typename: 'PropertyDistanceDetails' },
        contactNumber: { number: '+1 718 5333400', __typename: 'ContactNumber' },
        url: 'http://www.panynj.gov/airports/laguardia.html',
        complimentaryShuttle: false,
        id: 'LGA',
        __typename: 'PropertyAirport',
      },
      {
        name: 'Newark Liberty International Airport (EWR)',
        distanceDetails: { description: '15.1 mi NE', __typename: 'PropertyDistanceDetails' },
        contactNumber: { number: '+1 973 9616000', __typename: 'ContactNumber' },
        url: 'http://www.panynj.gov/airports/newark-liberty.html',
        complimentaryShuttle: false,
        id: 'EWR',
        __typename: 'PropertyAirport',
      },
      {
        name: 'John F Kennedy International Airport (JFK)',
        distanceDetails: { description: '16.6 mi NW', __typename: 'PropertyDistanceDetails' },
        contactNumber: { number: '+1 718 2444444', __typename: 'ContactNumber' },
        url: 'http://www.panynj.gov/airports/jfk.html',
        complimentaryShuttle: false,
        id: 'JFK',
        __typename: 'PropertyAirport',
      },
    ],
    otherTransportation: [
      {
        name: 'Hertz',
        contactInformation: { phones: ['+1 212 4865060'], __typename: 'SimpleContactInformation' },
        type: { description: 'Car Rental', code: 'Car Rental', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'NYC Bus Charters',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Bus Station', code: 'Bus Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'The Port Authority Bus Terminal',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Bus Station', code: 'Bus Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'New York City Passenger Ship Terminal',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Cruise Port', code: 'Cruise Port', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'Av- W 41 St.',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Local Bus Stops', code: 'Local Bus Stops', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'Grand Central Terminal Subway',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Subway Station', code: 'Subway Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'Penn Station',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Subway Station', code: 'Subway Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'Amtrak at Penn Station',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Train Station', code: 'Train Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
      {
        name: 'Grand Central Station',
        contactInformation: { phones: [], __typename: 'SimpleContactInformation' },
        type: { description: 'Train Station', code: 'Train Station', __typename: 'Lookup' },
        __typename: 'PropertyOtherTransportation',
      },
    ],
    reviews: {
      stars: { count: 4, __typename: 'starsContent' },
      numberOfReviews: { count: 1202, __typename: 'ReviewContent' },
      __typename: 'Reviews',
    },
    parking: [
      {
        fees: {
          fee: 'Fee: 50 USD daily',
          description: 'Off-site parking, fee: 50 USD daily',
          __typename: 'PropertyParkingFee',
        },
        description: null,
        __typename: 'PropertyParking',
      },
    ],
    policies: {
      checkInTime: '16:00',
      checkOutTime: '11:00',
      smokefree: true,
      petsAllowed: false,
      petsPolicyDescription: '',
      petsPolicyDetails: [],
      __typename: 'PropertyPolicies',
    },
    __typename: 'Hotel',
  },
};
